module.exports = __webpack_public_path__ + "static/img/2.3e1acb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail2/2.png
// module id = d2JT
// module chunks = 19